import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import ProfileSettings from '@Services/ProfileSettings';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';

import ResultsPerPage from './Components/ResultsPerPage';
import BlockHeading from '../../BlockHeading';
import PreferencesSectionItem from '../../PreferencesSectionItem';

function PreferencesResultsPerPageSection({ editUser, onChange, onSave, onClose }) {
  return (
    <div data-e2e="profile-settings-preferences-section-results-per-page">
      <BlockHeading title={ProfileSettingsConfig.Labels.resultsPerPage} />
      <PreferencesSectionItem
        name="RESULT_PER_PAGE"
        prefix="RESULT_PER_PAGE"
        value={editUser.RESULT_PER_PAGE.RX2_PAGE_SIZE}
        options={ProfileSettings.getCombinedInfo().RESULT_PER_PAGE.preferences}
        onChange={onChange}
        onClose={onClose}
        onSave={onSave}>
        <ResultsPerPage />
      </PreferencesSectionItem>
    </div>
  );
}

PreferencesResultsPerPageSection.propTypes = {
  editUser: PropTypes.object,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
};

PreferencesResultsPerPageSection.defaultProps = {
  onChange: noop,
  onSave: noop,
  onClose: noop,
};

export default PreferencesResultsPerPageSection;
